"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _transformFeatureNamesToFriendlyNames = require("./transformFeatureNamesToFriendlyNames");
Object.keys(_transformFeatureNamesToFriendlyNames).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _transformFeatureNamesToFriendlyNames[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _transformFeatureNamesToFriendlyNames[key];
    }
  });
});
